module.exports = __webpack_public_path__ + "img/img2.b97c99cd.jpg";